import angular from 'angular';
import languageManager from './LanguageManager';

export default angular.module('cms.language.changer', [languageManager]).component('cmsLanguageChanger', {
    template: require('./cmsLanguageChanger.html'),
    controller: function (languageManager, $rootScope) {

        this.setLanguage = function (language) {
            languageManager.setLanguage(language);
            $rootScope.$broadcast('language-changed', {newLanguage: language});
        };

        this.getCurrentLanguage = function () {
            return languageManager.getLanguage();
        };
    }
}).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Language/LanguageChanger.js